var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{staticClass:"group flex items-center px-2 py-2 text-sm font-medium rounded-md",class:[_vm.active ? 'bg-gray-200 text-gray-900' : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'],attrs:{"href":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }